import { render, staticRenderFns } from "./DesignerDocumentation.vue?vue&type=template&id=2dd4a5e9&scoped=true"
import script from "./DesignerDocumentation.vue?vue&type=script&lang=js"
export * from "./DesignerDocumentation.vue?vue&type=script&lang=js"
import style0 from "@/assets/docs/styles/documentation.css?vue&type=style&index=0&id=2dd4a5e9&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4a5e9",
  null
  
)

export default component.exports